import { Controller } from '@hotwired/stimulus'

import { withStaticCesiumMap } from '../src/mixins/cesium/with_cesium_map'
import { useZoomToEntities } from '../src/mixins/cesium/use_zoom_to_entities'

export default class extends Controller {
  static values = {
    accessToken: String,
    removeBackground: Boolean,
    pathUrl: String,
    points: { type: Array, default: [] },
    defaultAltitude: { type: Number, default: 0 }
  }

  connect () {
    // Build the Cesium Viewer
    this.viewer = withStaticCesiumMap(this, {
      accessToken: this.accessTokenValue
    })

    useZoomToEntities(this, { cesiumViewer: this.viewer })

    if (this.removeBackgroundValue) this.removeBackground()

    if (this.hasPathUrlValue) {
      this.addCzml(this.pathUrlValue)
    }

    if (this.pointsValue.length > 0) {
      this.addPoints(this.pointsValue)
    }
  }

  addCzml (czmlUrl) {
    // TODO: zoom to bounding box
    const dataSource = new Cesium.CzmlDataSource()
    const czmlPromise = dataSource.load(czmlUrl)
    this.viewer.dataSources.add(czmlPromise)
    this.viewer.homeButton.viewModel.command.beforeExecute.addEventListener(
      (e) => {
        e.cancel = true
        this.viewer.zoomTo(czmlPromise)
      })
    this.viewer.zoomTo(czmlPromise)
  }

  addPoints (points) {
    const defaultAlt = this.defaultAltitudeValue
    points.forEach((point, index) => {
      const altitude = point.altitude != null ? Number(point.altitude) : defaultAlt
      this.viewer.entities.add({
        position: Cesium.Cartesian3.fromDegrees(
          Number(point.longitude),
          Number(point.latitude),
          altitude
        ),
        id: `map_point_${index}`,
        name: `Point ${index + 1}`,
        point: {
          pixelSize: 10,
          color: Cesium.Color.YELLOW,
          outlineColor: Cesium.Color.WHITE,
          outlineWidth: 2
        },
        label: {
          text: String(index + 1),
          font: '14pt sans-serif',
          fillColor: Cesium.Color.WHITE,
          outlineColor: Cesium.Color.BLACK,
          outlineWidth: 2,
          style: Cesium.LabelStyle.FILL_AND_OUTLINE,
          verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
          pixelOffset: new Cesium.Cartesian2(0, -20)
        }
      })
    })
    this.viewer.zoomTo(this.viewer.entities)
  }

  removeBackground () {
    this.viewer.scene.globe.baseColor = Cesium.Color.LIGHTGREY
    this.viewer.scene.backgroundColor = Cesium.Color.ALICEBLUE

    this.viewer.scene.imageryLayers.removeAll()
    this.viewer.scene.sun.destroy()
    this.viewer.scene.sun = undefined

    this.viewer.scene.skyBox.destroy()
    this.viewer.scene.skyBox = undefined

    this.viewer.scene.skyAtmosphere.show = false
    this.viewer.scene.fog.enabled = false
    this.viewer.scene.globe.showGroundAtmosphere = false
  }
}
